import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { StatusOperacionalService } from '../services/status-operacional.servives';


@Injectable({
  providedIn: 'root'
})
export class StatusOperacionalResolver implements Resolve<boolean> {

  constructor(private service: StatusOperacionalService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}